const SLICE_NAME = 'agentModeSlice';

/**
 * HITL-1604: the one global mode that says what the supervising agent is allowed
 * to do while the AI runs the order.
 *
 * `Shadow` is **silent** — nothing the agent does in it reaches the customer or
 * the POS. `Intercept` is the only mode that can speak or send, and it is what
 * today's "agent has taken over" state becomes.
 *
 * Deliberately NOT a rename of `isAIAutoMode`, and nothing in this feature
 * writes to it: mutating that flag to fix a display symptom caused a production
 * incident (dropped orders + a cart revert).
 *
 * ## HITL-1647 — `Supervise` is gone
 *
 * It had no capability of its own. Its single distinguishing effect was hiding
 * the My Cart column; the silence, the disabled controls and the refusal to
 * reach the customer were identical to `Shadow`. What it cost was a decision the
 * agent had to make before the console would let them do anything — at the
 * moment they have least attention to spare, with a customer already talking.
 *
 * Two modes is the whole of the model now: watch, or take over.
 */
enum AgentMode {
  shadow = 'Shadow',
  intercept = 'Intercept',
}

/**
 * Every HITL session starts here, and returns here when an order ends. There is
 * no persistence — see the slice.
 *
 * HITL-1647 moved this from `Supervise` to `Shadow`, which is the substance of
 * retiring the third mode: the agent's own cart is on screen from the start, so
 * they can begin helping without opting in first. It is still the SILENT
 * default — the safety property that mattered about `Supervise` is unchanged,
 * because it was never `Supervise`'s to begin with.
 */
const DEFAULT_AGENT_MODE = AgentMode.shadow;

export { SLICE_NAME, AgentMode, DEFAULT_AGENT_MODE };
